export default __webpack_public_path__ + "static/media/pictogramDisability64.e9979ec1.svg";